import './divider.scss';

import { FC } from 'react';

import { cn } from '../../utils/helpers.ts';

export interface DividerProps {
  purpose: 'neutral' | 'invert';
  className?: string;
}

export const Divider: FC<DividerProps> = ({
  purpose = 'neutral',
  className,
}) => {
  return (
    <div className={cn(`Divider Divider--${purpose}`, className)} aria-hidden />
  );
};
